var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScissors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20018 1C3.40018 3.37059 5.00018 3.37059 4.20018 5.74118M7.40018 1C6.60018 3.37059 8.20018 3.37059 7.40018 5.74118",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 16.8053C3.48366 16.8053 4.2 16.0978 4.2 15.2249C4.2 14.3521 3.48366 13.6445 2.6 13.6445C1.71634 13.6445 1 14.3521 1 15.2249C1 16.0978 1.71634 16.8053 2.6 16.8053Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71973 14.116L5.79973 12.0615M8.03973 9.84894L10.5997 7.32031",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9999 16.8053C9.88356 16.8053 10.5999 16.0978 10.5999 15.2249C10.5999 14.3521 9.88356 13.6445 8.9999 13.6445C8.11625 13.6445 7.3999 14.3521 7.3999 15.2249C7.3999 16.0978 8.11625 16.8053 8.9999 16.8053Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.32157L7.88 14.1173M13.8 1H15.4C15.8243 1 16.2313 1.16651 16.5314 1.46289C16.8314 1.75927 17 2.16125 17 2.58039V15.2235C17 15.6427 16.8314 16.0447 16.5314 16.341C16.2313 16.6374 15.8243 16.8039 15.4 16.8039H13.8M13.8 4.16079H17M13.8 7.32157H17M13.8 10.4824H17M13.8 13.6431H17",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissors);
export default __webpack_public_path__ + "static/media/scissors.adff808be972425eefeff16f63c9d3c6.svg";
export { ForwardRef as ReactComponent };